import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core';

@Component({
    tag: 'ti-breadcrumb-section',
    styleUrl: 'breadcrumb-section.scss',
    scoped: true
})
export class BreadcrumbSection {

    /**
     * Breadcrumb reference id - required for metrics.
     *
     * @type {string}
     */
    @Prop() bid: string;

    /**
     * English breadcrumb label - used for metrics data.
     *
     * @type {string}
     */
    @Prop() enLabel: string;

    /**
     * Flag to check if the breadcrumb is the `Home` breadcrumb.
     *
     * @type {boolean}
     * @default `false`
     */
    @Prop() isHome: boolean = false;

    /**
     * Breadcrumb label.
     *
     * @type {string}
     */
    @Prop() label: string;

    /**
     * Number of subitems shown on the hover dropdown-panel.
     *
     * @type {number}
     */
    @Prop() size: number = 0;

    /**
     * Emit an event on hover of breadcrumb section.
     */
    @Event() tiBreadcrumbHover: EventEmitter;

    /**
     * calculate the number of columns needed to render the breadcrumb dropdown-panel options
     * @param {number} children - length of sub entries in the breadcrumb list
     * @returns {number} - number of columns needed
     */
    private _adjustColumns(children: number):number {
        // max items to show per column
        const maxItemsPerColumn = 10;
        // return number of columns needed
        return Math.ceil(children / (maxItemsPerColumn));
    }

    /**
     * function on hover of breadcrumb-section
     * will emit an event that is used by metrics
     * @returns {void}
     */
    private _onHoverBreadcrumbSection(): void {
        // e.g. breadcrumb_1 - Amplifiers
        this.tiBreadcrumbHover.emit(`breadcrumb_${this.bid} - ${this.enLabel || this.label}`);
    }

    render() {
        return (
            <Host>
                {
                    this.size > 0 ?
                        <div class="ti-breadcrumb-section" onMouseEnter={() => this._onHoverBreadcrumbSection()}>
                            <span aria-hidden="true" class="ti-breadcrumb-section__separator">/</span>
                            <ti-dropdown-panel hover>
                                <div slot="trigger" class="ti-breadcrumb-section-trigger">
                                    <slot name="trigger" />
                                </div>
                                <div slot="content" class="ti-breadcrumb-section-list" style={{ columnCount: `${this._adjustColumns(this.size)}` }}>
                                    <slot />
                                </div>
                            </ti-dropdown-panel>
                        </div>
                        :
                        <div class={(this.isHome ? 'ti-breadcrumb-home-section' : 'ti-breadcrumb-section')} onMouseEnter={() => this._onHoverBreadcrumbSection()}>
                            {
                                !this.isHome && <span aria-hidden="true" class="ti-breadcrumb-section__separator">/</span>
                            }
                            <slot name="trigger" />
                        </div>
                }
            </Host>
        );
    }
}
